import { useState } from 'react'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import TagList from 'components/TagList'
import AIPromptText from 'components/AIPromptText'
import ImageContainer from 'components/ImageContainer'
import SmartPromptArea from '../SmartPromptSection'
import { useAiVideoItemTagsData } from '../../hooks/useAiVideoItemTagsData'
import { normalizeAspectRatio } from 'utils/aspectRatio'
import * as Styled from './styled'

const SmartEditContent = () => {
  const prompt = useSelector(aiVideoSelectors.prompt)
  const smartPrompt = useSelector(aiVideoSelectors.smartPrompt)
  const uploadedImagePath = useSelector(aiVideoSelectors.uploadedImagePath)
  const aspectRatio = useSelector(aiVideoSelectors.aspectRatio)
  const quality = useSelector(aiVideoSelectors.quality)
  const selectedModelCode = useSelector(aiVideoSelectors.selectedModelCode)
  const getItemTags = useAiVideoItemTagsData()
  const [isImageLoading, setIsImageLoading] = useState(true)

  const tags = getItemTags(quality, selectedModelCode)

  return (
    <Styled.SmartEditContainer>
      <Styled.InfoSection>
        <TagList tags={tags} />
        <Styled.ImageWrapper>
          <ImageContainer
            filePath={uploadedImagePath}
            isImageLoading={isImageLoading}
            onImageLoad={() => setIsImageLoading(false)}
            aspectRatio={normalizeAspectRatio(aspectRatio)}
          />
        </Styled.ImageWrapper>
        {prompt && <AIPromptText promptText={prompt} />}
      </Styled.InfoSection>
      <Styled.Divider />
      <SmartPromptArea smartPrompt={smartPrompt} />
    </Styled.SmartEditContainer>
  )
}

export default SmartEditContent
